import { Component } from '@angular/core';
import { GridOptions, GridReadyEvent } from '@ag-grid-community/core';
import { JoPullBatch, JoStatus } from 'app/model/entities/entity-model';
import { AgFns, GridOptionsExt, RowSelectionSingle } from 'app/shared/ag-fns';
import { DialogBaseComponent, DialogParams } from 'app/shared/dialog-base.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DomainService } from 'app/shared/domain.service';

export interface ChangeJoPullBatchDialogParams extends DialogParams {
  joPullBatchId: number;
}

@Component({
    templateUrl: './change-jo-pull-batch-dialog.component.html',
    standalone: false
})
export class ChangeJoPullBatchDialogComponent extends DialogBaseComponent<ChangeJoPullBatchDialogParams> {
  joPullBatchId: number;
  joPullBatches: JoPullBatch[];
  jopbGridOptions: GridOptionsExt;

  constructor( public config: DynamicDialogConfig<ChangeJoPullBatchDialogParams>, public dialogRef: DynamicDialogRef, public domainService: DomainService) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: "Switch to batch:",
      width: '830px',
      height: '510px',
      
    })
    this.prepare();
  }
 

  async prepare() {
    this.joPullBatchId = this.params.joPullBatchId;
    this.jopbGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onJopbGridReady,
      onRowDoubleClicked: this.selectBatch,
      rowSelection: RowSelectionSingle,
    }, { detailProperty: 'joHeaderPulls' });
    this.updateJopbMasterDetail(this.jopbGridOptions);

    this.joPullBatches = await this.dbQueryService.getJoPullBatches();
    this.isPageReady = true;
  }

  onJopbGridReady(event: GridReadyEvent) {
    const colDefs = [
      { headerName: 'Batch Id', field: 'id', filter: 'agNumberColumnFilter', cellRenderer: 'agGroupCellRenderer'  },
      { headerName: 'User Init', field: 'userInit', filter: 'agTextColumnFilter' },
    ];
    
    AgFns.initGrid(event, colDefs);
    AgFns.sizeColumnsToFit(this.jopbGridOptions);
  }

  updateJopbMasterDetail(parentGridOptions: GridOptions) {
    const detailGridOptions = AgFns.createDetailGridOptions();
    detailGridOptions.columnDefs = [
      { headerName: 'Job Order Id', field: 'joHeaderId', width: 100 },
      { headerName: 'Account', field: 'joHeader.account.accountName', filter: 'agTextColumnFilter' },
      { ...AgFns.createSetFilterObjectProps('Status', 'joHeader.joStatus.name', this.dbQueryService.getAllCached(JoStatus)) },
      { headerName: 'J/O Date', field: 'joHeader.joDate', filter: 'agDateColumnFilter' },
      
    ];
    AgFns.updateColDefs(detailGridOptions.columnDefs);
    parentGridOptions.detailCellRendererParams = {
      detailGridOptions: detailGridOptions,
      getDetailRowData: params => {
        const jopb = params.data as JoPullBatch;
        params.successCallback(jopb.joHeaderPulls);
      },
    };
  }

  async selectBatch() {
    const selectedJoPullBatches = <JoPullBatch[]> this.jopbGridOptions.apiX.getSelectedRows();
    if (selectedJoPullBatches.length === 0) {
      await this.dialogService.showOkMessage('Nothing was selected','No Job Order Pull Batch was selected');
      return;
    }
    this.dialogRef.close( { joPullBatchId: selectedJoPullBatches[0].id });
  }

  close() {
    this.dialogRef.close(null);
  }

}
